/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import Dictionary from '../interfaces/dictionary';

enum Provider {
  Google = 'google',
  Mapbox = 'mapbox'
}

const DirectionsProviderList: Dictionary[] = [
  { key: Provider.Google, value: 'Google' },
  { key: Provider.Mapbox, value: 'Mapbox' }
];

export {
  Provider,
  DirectionsProviderList
};
